<path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6 12.001C6 11.4487 6.44772 11.001 7 11.001H17C17.5523 11.001 18 11.4487 18 12.001C18 12.5533 17.5523 13.001 17 13.001H7C6.44772 13.001 6 12.5533 6 12.001Z"
    fill="currentColor"
/>
